import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiGetListRfpQuestion } from '@/actions/ProfessionalRfpQuestionActions';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { wrapDispatch } from '@/helpers/action';
import { propShape } from '@/helpers/custom-prop-types';
const RfpQuestionHoc = (setting, ChildSkeletonComponent) => (ChildComponent) => {
    const RfpQuestionHocInner = (props) => {
        const { rfp: { id }, } = props;
        const dispatch = useDispatch();
        const question = useSelector((state) => state.professionalRfpQuestion.one[id]);
        const [loading, changeLoading] = useState(!question);
        useEffect(() => {
            let unmount = false;
            changeLoading(true);
            wrapDispatch(dispatch, apiGetListRfpQuestion({ path: { id } }, { id })).finally(() => {
                if (!unmount) {
                    changeLoading(false);
                }
            });
            return () => {
                unmount = true;
            };
        }, [id, dispatch, changeLoading]);
        if (loading === false && !question) {
            return (_jsx(CustomRedirect, { to: (setting && setting.redirect) || `/project/professional/${id}` }));
        }
        if (loading && !question) {
            return _jsx(ChildSkeletonComponent, {});
        }
        return _jsx(ChildComponent, Object.assign({}, props, { question: question }));
    };
    RfpQuestionHocInner.propTypes = {
        rfp: propShape().isRequired,
    };
    return RfpQuestionHocInner;
};
export default RfpQuestionHoc;
